import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { config } from '@app/core/app-config';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ArticlePage, CategoryPage, HomePage, SearchResult } from '../models/support-documentation';

@Injectable({
  providedIn: 'root',
})
export class SupportDocumentationService {
  private baseUrl = `${config.API_URL}/support_documentation`;

  constructor(private http: HttpClient) {}

  getHomePage(): Observable<HomePage> {
    return this.http.get(this.baseUrl).pipe(map((res: { data: HomePage }) => res.data));
  }

  getCategoryPage(slug: string): Observable<CategoryPage> {
    return this.http.get(this.baseUrl + '/categories/' + slug).pipe(map((res: { data: CategoryPage }) => res.data));
  }

  getArticlePage(slug: string): Observable<ArticlePage> {
    return this.http.get(this.baseUrl + '/articles/' + slug).pipe(map((res: { data: ArticlePage }) => res.data));
  }

  search(query: string): Observable<SearchResult> {
    return this.http.get(this.baseUrl + '/search?q=' + query).pipe(map((res: { data: SearchResult }) => res.data));
  }

  sendFeedback(articleSlug: string, feedback: 'positive' | 'negative'): Observable<any> {
    return this.http.post(this.baseUrl + '/articles/' + articleSlug + '/feedback', { feedback });
  }
}
